import { useState } from "react";
import { C, Card, Tag } from "./theme";

const ROADMAP = [
  { ver: "v1.0", label: "Live now",  title: "Tracking + AI + Email auto-import", done: true,  color: C.accent,
    items: [
      "Manual income / expense tracking by family member",
      "AI-powered financial advisor (Claude) — 5 free analyses/month",
      "Personalised investment allocation by risk profile",
      "Emergency fund calculation from essential expenses only",
      "Financial goals — editable target / progress / icon / colour",
      "Family sharing — spouse joint account access",
      "📧 Email auto-import — HDFC, ICICI, SBI bank alerts",
      "🔄 Refund detection — auto-link credits to prior expenses",
      "📅 Scheduled bills — e-mandate / auto-debit notices as recurring transactions",
      "Vendor → category auto-classification",
      "DPDP Act 2023 + IT Act 2000 compliant",
    ]
  },
  { ver: "v1.5", label: "Next sprint", title: "Goal-transaction mapping, reminders, Pro tier", done: false, color: C.gold,
    items: [
      "🔗 Map goals to transactions — tag spend or income toward a specific goal (e.g., \"home down payment\" tag auto-adds to that goal's progress)",
      "📬 Bill reminders — email notification 1-3 days before scheduled debits",
      "More bank parsers — Kotak, Yes Bank, IndusInd, RBL, Federal",
      "Credit card statement parsing — HDFC, ICICI, SBI cards",
      "💎 Pro tier (₹99/mo) — unlimited AI analyses, faster priority queue",
      "Per-transaction \"essential\" toggle override",
      "Dashboard charts — 7-month income/expense/savings trend",
      "Value-weighted sector view — integrate NSE/BSE price API",
      "NSDL CAS parser (in addition to CDSL)",
    ]
  },
  { ver: "v2.0", label: "Q3 2026", title: "Bank statements + transfer detection", done: false, color: C.blue,
    items: [
      "Bank statement upload (PDF/CSV — all major Indian banks)",
      "UPI export support (PhonePe, GPay, Paytm)",
      "Fund transfer detection — 4-layer AI excludes inter-account moves",
      "Duplicate detection across email + statement imports",
      "Multi-account manager",
    ]
  },
  { ver: "v2.5", label: "Q4 2026", title: "Full tax engine + advance tax calendar", done: false, color: C.purple,
    items: [
      "Full tax engine — all income heads, 80C/D/E/G/HRA/NPS",
      "Old vs new regime comparison — auto-recommends best",
      "Real-time Tax-O-Meter — live FY tax estimate",
      "Advance tax calendar — Jun/Sep/Dec/Mar instalments",
      "Tax savings optimiser — AI ranks your best moves before Mar 31",
    ]
  },
  { ver: "v3.0", label: "Q1 2027", title: "Broker + AA integrations", done: false, color: C.gold,
    items: [
      "Zerodha Kite — OAuth, holdings, LTCG/STCG, tax harvesting",
      "Upstox — free API, P&L reports",
      "CAMS CAS — covers Scripbox, Groww, ET Money, all MF platforms",
      "NPS via NSDL, EPF via EPFO",
      "Account Aggregator (RBI) — consent-based, bank-mandated",
    ]
  },
  { ver: "v3.5", label: "Q2 2027", title: "Net worth, FIRE, XIRR, mobile app", done: false, color: C.orange,
    items: [
      "Net worth dashboard — assets vs liabilities, monthly trend",
      "XIRR per investment vs benchmark",
      "FIRE calculator — time to Financial Independence",
      "Conversational AI coach + WhatsApp digest",
      "Mobile app — React Native, biometric login, offline mode",
    ]
  },
];

export default function RoadmapScreen() {
  const [open, setOpen] = useState("v2.0");
  return (
    <div style={{ display: "flex", flexDirection: "column", gap: 12 }}>
      <Card style={{ padding: "14px 20px", display: "flex", gap: 20 }}>
        {[["6","Phases"], ["40+","Features"], ["Q2 '27","Full launch"], ["v3.5","Target"]].map(([n, l]) => (
          <div key={l} style={{ textAlign: "center", flex: 1 }}>
            <div style={{ fontSize: 22, fontWeight: 800, color: C.accent }}>{n}</div>
            <div style={{ fontSize: 11, color: C.muted }}>{l}</div>
          </div>
        ))}
      </Card>

      {ROADMAP.map(item => (
        <Card key={item.ver} style={{ padding: 0, border: item.done ? `1px solid ${C.accent}44` : `1px solid ${C.border}` }}>
          <div onClick={() => setOpen(open === item.ver ? null : item.ver)}
            style={{ padding: "14px 18px", display: "flex", alignItems: "center", gap: 14, cursor: "pointer", flexWrap: "wrap" }}>
            <div style={{ width: 12, height: 12, borderRadius: "50%", background: item.done ? item.color : "transparent", border: `2px solid ${item.color}`, flexShrink: 0 }} />
            <Tag c={item.color}>{item.ver}</Tag>
            <span style={{ fontSize: 13, color: C.muted, fontWeight: 600, minWidth: 60 }}>{item.label}</span>
            <span style={{ flex: 1, fontSize: 13, fontWeight: 700, color: C.text, minWidth: 200 }}>{item.title}</span>
            {item.done ? <Tag c={C.success}>✓ Live</Tag> : <span style={{ color: C.muted, fontSize: 14 }}>{open === item.ver ? "▴" : "▾"}</span>}
          </div>
          {open === item.ver && (
            <div style={{ padding: "0 18px 16px 18px", borderTop: `1px solid ${C.border}` }}>
              <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(220px, 1fr))", gap: 8, paddingTop: 14 }}>
                {item.items.map(f => (
                  <div key={f} style={{ display: "flex", gap: 8, fontSize: 12, color: C.muted, alignItems: "flex-start" }}>
                    <span style={{ color: item.color, flexShrink: 0, marginTop: 1 }}>›</span>{f}
                  </div>
                ))}
              </div>
            </div>
          )}
        </Card>
      ))}
    </div>
  );
}
